import React, { lazy } from 'react'

const SubmitVideoRefPage = lazy(() => import('./SubmitVideoRefPage'))

export { SubmitVideoRefPage }
